import BaseError from "./BaseError";

export default class BadRequestError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "BadRequestError";
  }
}
